/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Plans } from '../constants';
import useSubscriptionPlanPrices from '../../hooks/useSubscriptionPlanPrices';

const OptionButtons = ({
  flags,
  handleChange,
  selected,
  getCouponContentKey,
  defaultSeasonalTitle,
  defaultSeasonalPrice,
  defaultSeasonalSubText,
  defaultAnnualTitle,
  defaultAnnualPrice,
  defaultAnnualSubText,
  strikethroughText,
  boldAnnualSubText,
}) => {
  const { seasonalPrice, annualPrice } = useSubscriptionPlanPrices();
  const seasonalTitle = defaultSeasonalTitle || 'SEASONAL';
  const seasonalSubText = defaultSeasonalSubText || 'Standard';
  const annualTitle = defaultAnnualTitle || 'ANNUAL';
  const [annualSubText, setAnnualSubText] = useState('');
  const [prioritizedSeasonalPrice, setPrioritizedSeasonalPrice] = useState(null);
  const [prioritizedAnnualPrice, setPrioritizedAnnualPrice] = useState(null);

  useEffect(() => {
    setPrioritizedSeasonalPrice(defaultSeasonalPrice || `$${seasonalPrice} USD`);
    setPrioritizedAnnualPrice(defaultAnnualPrice || `$${annualPrice} USD`);
    setAnnualSubText(defaultAnnualSubText || `$${annualPrice} USD!`);
  }, [defaultSeasonalPrice, defaultAnnualPrice, defaultAnnualSubText, seasonalPrice, annualPrice]);

  const displayStrikeThroughText = () => {
    if (defaultAnnualPrice || annualPrice) {
      return prioritizedAnnualPrice !== annualSubText.substring(0, annualSubText.length - 1);
    }
    return false;
  };


  return (
    <div data-testid="ob-container" className="trial-upgrade__buttons">
      <div
        data-testid="ob-seasonal-box"
        className={cx('trial-upgrade__buttons__box', { active: selected === Plans.SEASONAL })}
        role="button"
        tabIndex="0"
        onClick={() => handleChange(Plans.SEASONAL)}
        onKeyDown={() => handleChange(Plans.SEASONAL)}
      >
        {selected === Plans.SEASONAL && (
          <div
            data-testid="ob-active-check"
            className="active-check"
          >
            <i className="fas fa-check-circle" />
          </div>
        )}
        <div data-testid="ob-seasonal-title" className="trial-upgrade__buttons__title">
          {getCouponContentKey('seasonalPlan.title', seasonalTitle)}
        </div>
        {seasonalPrice && (
          <div data-testid="ob-seasonal-price" className="trial-upgrade__buttons__price">
            {`$${seasonalPrice} USD`}
          </div>
        )}
        <div data-testid="ob-seasonal-button-type" className="trial-upgrade__buttons__type">
          {getCouponContentKey('seasonalPlan.note', seasonalSubText)}
        </div>
      </div>
      <div
        data-testid="ob-annual-box"
        className={cx('trial-upgrade__buttons__box', { active: selected === Plans.ANNUAL })}
        role="button"
        tabIndex="0"
        onClick={() => handleChange(Plans.ANNUAL)}
        onKeyDown={() => handleChange(Plans.ANNUAL)}
      >
        {selected === Plans.ANNUAL && (
          <div
            className="active-check"
          >
            <i className="fas fa-check-circle" />
          </div>
        )}
        <div data-testid="ob-annual-title" className="trial-upgrade__buttons__title">
          {getCouponContentKey('annualPlan.title', annualTitle)}
        </div>
        {displayStrikeThroughText() && (
          <div className={cx('trial-upgrade__buttons__price', { through: strikethroughText })}>
            {getCouponContentKey('annualPlan.subtitle', prioritizedAnnualPrice)}
          </div>
        )}
        {(defaultAnnualSubText || annualPrice) && (
          <div
            data-testid="ob-annual-sub-price"
            className={
            cx('spaced',
              {
                'trial-upgrade__buttons__price': boldAnnualSubText,
                'trial-upgrade__buttons__type': !boldAnnualSubText,
              })
          }
          >
            {`$${annualPrice} USD!`}
          </div>
        )}
      </div>
    </div>
  );
};

OptionButtons.defaultProps = {
  handleChange: () => null,
  selected: Plans.SEASONAL,
  getCouponContentKey: (key, defaultValue) => (defaultValue),
  defaultSeasonalTitle: '',
  defaultSeasonalPrice: '',
  defaultSeasonalSubText: '',
  defaultAnnualTitle: '',
  defaultAnnualPrice: '',
  defaultAnnualSubText: '',
  strikethroughText: true,
  boldAnnualSubText: true,
};

OptionButtons.propTypes = {
  handleChange: PropTypes.func,
  selected: PropTypes.string,
  getCouponContentKey: PropTypes.func,
  defaultSeasonalTitle: PropTypes.string,
  defaultSeasonalPrice: PropTypes.string,
  defaultSeasonalSubText: PropTypes.string,
  defaultAnnualTitle: PropTypes.string,
  defaultAnnualPrice: PropTypes.string,
  defaultAnnualSubText: PropTypes.string,
  strikethroughText: PropTypes.bool,
  boldAnnualSubText: PropTypes.bool,
};

export default OptionButtons;
